// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

/* Garantir que o Header do Estado não seja afetado por CSS global */
.App > div:first-child {
  width: 100vw !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Garantir que o Header do Estado fique no topo absoluto */
pr-header {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  z-index: 99999 !important;
  height: 46px !important;
  min-width: 100% !important;
}

/* 
 * Reason: O pr-header no mobile tem altura reduzida com scaleY para
 * ocupar menos espaço vertical. A altura visual resultante é ~28px.
 */
@media (max-width: 768px) {
  pr-header {
    height: 36px !important;
    width: 100vw !important;
    min-width: 100% !important;
    transform: scaleY(0.78) !important;
    transform-origin: top !important;
  }
}

/* 
 * Reason: O espaçamento para compensar os elementos fixos (HeaderEstadual, LogoSection, Navbar)
 * agora é controlado pelo componente Layout.tsx usando paddingTop dinâmico.
 * Os estilos globais de padding-top foram removidos para evitar conflitos.
 */

/* Estilos gerais */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-subtitle {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.cta-button {
  background: linear-gradient(45deg, #ff6b6b, #ee5a24);
  color: white;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Section Titles */
.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 3rem;
  color: #333;
  text-align: center;
}

/* Features Section */
.features-section {
  background: #f8f9fa;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.feature-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-card h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
}

/* About Section */
.about-section {
  background: white;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
  color: #555;
  font-size: 1.1rem;
}

/* Contact Section */
.contact-section {
  background: #f8f9fa;
}

.contact-info {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.contact-info p {
  margin: 1rem 0;
  font-size: 1.1rem;
  color: #555;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .container {
    padding: 0 15px;
  }
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.error-container h2 {
  color: #dc3545;
  margin-bottom: 1rem;
}

.error-container p {
  color: #666;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;EAGE;AACF;EACE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;IAClC,gCAAgC;EAClC;AACF;;AAEA;;;;EAIE;;AAEF,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2FAA2F;AAC7F;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n}\n\n/* Garantir que o Header do Estado não seja afetado por CSS global */\n.App > div:first-child {\n  width: 100vw !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* Garantir que o Header do Estado fique no topo absoluto */\npr-header {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  z-index: 99999 !important;\n  height: 46px !important;\n  min-width: 100% !important;\n}\n\n/* \n * Reason: O pr-header no mobile tem altura reduzida com scaleY para\n * ocupar menos espaço vertical. A altura visual resultante é ~28px.\n */\n@media (max-width: 768px) {\n  pr-header {\n    height: 36px !important;\n    width: 100vw !important;\n    min-width: 100% !important;\n    transform: scaleY(0.78) !important;\n    transform-origin: top !important;\n  }\n}\n\n/* \n * Reason: O espaçamento para compensar os elementos fixos (HeaderEstadual, LogoSection, Navbar)\n * agora é controlado pelo componente Layout.tsx usando paddingTop dinâmico.\n * Os estilos globais de padding-top foram removidos para evitar conflitos.\n */\n\n/* Estilos gerais */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n}\n\n.hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.hero-title {\n  font-size: 3.5rem;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.hero-subtitle {\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.cta-button {\n  background: linear-gradient(45deg, #ff6b6b, #ee5a24);\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  font-size: 1.1rem;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Section Titles */\n.section-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin-bottom: 3rem;\n  color: #333;\n  text-align: center;\n}\n\n/* Features Section */\n.features-section {\n  background: #f8f9fa;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.feature-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n}\n\n.feature-card h3 {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.feature-card p {\n  color: #666;\n  line-height: 1.6;\n}\n\n/* About Section */\n.about-section {\n  background: white;\n}\n\n.about-content {\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.8;\n  color: #555;\n  font-size: 1.1rem;\n}\n\n/* Contact Section */\n.contact-section {\n  background: #f8f9fa;\n}\n\n.contact-info {\n  max-width: 600px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.contact-info p {\n  margin: 1rem 0;\n  font-size: 1.1rem;\n  color: #555;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.2rem;\n  }\n  \n  .section-title {\n    font-size: 2rem;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .container {\n    padding: 0 15px;\n  }\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  text-align: center;\n  padding: 20px;\n}\n\n.error-container h2 {\n  color: #dc3545;\n  margin-bottom: 1rem;\n}\n\n.error-container p {\n  color: #666;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
